import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
/**
 * Sort `filters` by the server-persisted `filter_order` array.
 * IDs present in `order` appear first in that order; any remaining filters
 * (e.g. newly pinned, not yet in the order) are appended in their original
 * array position (creation order from the API).
 */
export var applyFilterOrder = function applyFilterOrder(filters, order) {
  if (!order.length) return filters;
  var byId = new Map(filters.map(function (f) {
    return [f.id, f];
  }));
  var ordered = order.map(function (id) {
    return byId.get(id);
  }).filter(function (f) {
    return !!f;
  });
  var inOrder = new Set(order);
  var remainder = filters.filter(function (f) {
    return !inOrder.has(f.id);
  });
  return [].concat(_toConsumableArray(ordered), _toConsumableArray(remainder));
};